import { DatePicker, Form } from 'antd';

import { DATE_FORMAT, getTimezoneDayjs } from '@/utils/time';

const { RangePicker } = DatePicker;

export const DateRangeField = (props: {
  display: boolean;
  required?: boolean;
}) => {
  const { display, required = false } = props;

  return (
    <div
      className="flex flex-1 items-center gap-2"
      style={{ display: display ? 'block' : 'none' }}
    >
      {/* Hidden form fields for actual data storage */}
      <Form.Item name="start_date" hidden>
        <input />
      </Form.Item>
      <Form.Item name="end_date" hidden>
        <input />
      </Form.Item>

      {/* Visual date range picker with shouldUpdate */}
      <Form.Item
        label="Date range"
        layout="vertical"
        required={required}
        labelCol={{ flex: 1 }}
        shouldUpdate={(prevValues, currentValues) =>
          prevValues.start_date !== currentValues.start_date ||
          prevValues.end_date !== currentValues.end_date
        }
      >
        {({ getFieldValue, setFieldValue }) => {
          const startDate = getFieldValue('start_date');
          const endDate = getFieldValue('end_date');

          // Validation logic
          const hasError = !startDate || !endDate;

          return (
            <div>
              <RangePicker
                value={(() => {
                  if (!startDate && !endDate) return undefined;

                  return [
                    startDate ? getTimezoneDayjs(startDate) : null,
                    endDate ? getTimezoneDayjs(endDate) : null,
                  ];
                })()}
                format={DATE_FORMAT.readable}
                style={{ width: '100%' }}
                allowClear
                allowEmpty
                onChange={(values) => {
                  if (!values) {
                    // Clear both fields when RangePicker is cleared
                    setFieldValue('start_date', null);
                    setFieldValue('end_date', null);
                    return;
                  }

                  const [start, end] = values;

                  setFieldValue('start_date', start?.toJSON() || null);
                  setFieldValue('end_date', end?.toJSON() || null);
                }}
              />
              {hasError && (
                <div
                  style={{
                    color: '#ff4d4f',
                    fontSize: '14px',
                    marginTop: '4px',
                  }}
                >
                  Date range is required
                </div>
              )}
            </div>
          );
        }}
      </Form.Item>
    </div>
  );
};
